/** Копирование считается успешным только после подтверждения Clipboard API. */
export async function copyText(value: string): Promise<void> {
	if (!navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') {
		throw new Error('Буфер обмена недоступен в этом браузере');
	}

	await navigator.clipboard.writeText(value);
}
